import React from 'react';
import { CartItemType } from '@base/cart/interface';

type CartItemAttrsProps = {
    className?: string;
    item: CartItemType;
};

const CartItemAttrs: React.FC<CartItemAttrsProps> = props => {
    const { className, item: { productSkuNum, optionValueList } } = props;
    return productSkuNum > 1 ? (
        <div className={className}>
            {optionValueList.join(' / ')}
        </div>
    ) : null;
};

export default CartItemAttrs;